import { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { DropDownList } from "../Components/DropDownList";
import { UploadPicture } from "../Components/UploadPicture";
import { FormSectionTitle } from "../Components/FormSectionTitle";
import { Box, Typography } from "@mui/material";
import { addEspaceCharacters, config, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { useAuth } from "../Components/AuthContext";
import { LoaderBox } from "../Components/LoaderBox";

const REGLAS_PASSWORD =
  "Mínimo 8 caracteres, con al menos una mayúscula, una minúscula, un número y uno de los siguientes caracteres especiales: !@#$%&_";

function MiCuenta() {
  const [userInfo, setUserInfo] = useState({});
  const [actividadInv, setActividadInv] = useState({ Id: "", Nombre: "" });
  const [dialog, setDialog] = useState({ title: "", text: "" });
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [newPassword, setNewPassword] = useState(false);
  const [errorText, setErrorText] = useState("");
  const { user, login } = useAuth();
  const [passwordError, setPasswordError] = useState(false);
  const [verifyPasswordError, setVerifyPasswordError] = useState(false);

  function validatePassword(password) {
    // Verifica que la cadena tenga un largo mínimo de 8 caracteres
    if (password.length < 8) {
      setErrorText("La contraseña debe tener por lo menos 8 caracteres.");
      return false;
    }

    // Verifica que la cadena contenga por lo menos una letra mayúscula
    if (!/[A-Z]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // Verifica que la cadena contenga por lo menos una letra minúscula
    if (!/[a-z]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // Verifica que la cadena contenga por lo menos un número
    if (!/[0-9]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // Verifica que la cadena contenga por lo menos un caracter especial
    if (!/[!@#$%&_]/.test(password)) {
      setErrorText(
        "La contraseña debe contener por lo menos una letra mayúscula, una minúscula, un número y uno o más de los siguiente caracteres espciales !@#$%&_"
      );
      return false;
    }

    // La cadena cumple con todos los requisitos
    setErrorText("");
    return true;
  }
  if (loading && user) {
    instance
      .get("/users/getById/" + user.id)
      .then((res) => {
        res.data = {
          ...res.data,
          fotografia: config.profile_url + res.data.fotografia,
        };
        setUserInfo(res.data);
        setActividadInv(res.data.actividadInv);
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message });
        }
        setOpenDialog(true);
      })
      .finally(() => setLoading(false));
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUserInfo({ ...userInfo, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let apiEndpoint;
    if (newPassword && !verifyPassword()) return;
    const info = e.target;
    const formData = new FormData(); // contiene los valores si es actualizacion completa
    formData.append("id", user.id);
    formData.append("nombre", addEspaceCharacters(info.nombre.value));
    formData.append("apellido", addEspaceCharacters(info.apellido.value));
    formData.append("actividadInv", actividadInv.Id);
    formData.append("profesion", addEspaceCharacters(info.profesion.value));
    formData.append("especialidad", addEspaceCharacters(info.especialidad.value));
    formData.append("password", info.password.value);

    let form = { // contiene los valores si es actualizacion parcial
      id: user.id,
      nombre: addEspaceCharacters(info.nombre.value),
      apellido: addEspaceCharacters(info.apellido.value),
      actividadInv: actividadInv.Id === "" ? userInfo.actividadInv : actividadInv.Id,
      profesion: addEspaceCharacters(info.profesion.value),
      especialidad: addEspaceCharacters(info.especialidad.value),
      password: info.password.value,
    };
    if (newPassword) {
      formData.append("newpassword", info.newPassword.value);
      form = {
        ...form,
        newpassword: info.newPassword.value,
      };
    }
    if (!e.target.upload_image.files[0]) {
      apiEndpoint = "/users/updatePartial";
    } else {
      apiEndpoint = "/users/updateFull";
      formData.append("fotografia", info.upload_image.files[0]);
    }
    instance
      .put(apiEndpoint, e.target.upload_image.files[0] ? formData : form)
      .then((res) => {
        setDialog({
          title: "Actualización exitosa",
          text: `${res.data.nombre}, se han actualizado los datos de tu cuenta de forma exitosa.`,
        });
        login(user.accessToken, res.data);
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message });
        }
      })
      .finally(() => setOpenDialog(true));
  };
  const verifyPassword = () => {
    const password = document.querySelector("#newPassword").value;
    const confirmation = document.querySelector("#confirmPassword").value;
    if (password !== confirmation) {
      setErrorText("Error: La contraseña y su confirmación no son iguales.");
      return false;
    } else {
      setErrorText("");
      return true;
    }
  };

  return (
    <LoaderBox isLoading={loading}>
      <Container maxWidth="md" sx={{ marginTop: 2, marginBottom: 4 }}>
        <Box sx={{ marginBottom: 2 }}>
          <h2 style={{ textAlign: "center" }}>Mi cuenta</h2>
        </Box>
        <Box
          component="main"
          className="bordered-box"
          sx={{
            padding: { xs: "8px", sm: "24px" },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            component="form"
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            onSubmit={handleSubmit}
            sx={{ width: "100%" }}
          >
            <Grid item xs={12} sm={12} sx={{ display: "flex", justifyContent: "center" }}>
              <UploadPicture imagen={userInfo.fotografia} />
            </Grid>

            <FormSectionTitle>Datos personales</FormSectionTitle>

            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="nombre"
                label="Nombre(s)"
                name="nombre"
                value={userInfo.nombre}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="apellido"
                label="Apellido(s)"
                name="apellido"
                value={userInfo.apellido}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="correo"
                label="Correo electrónico"
                name="correo"
                disabled
                value={userInfo.correo}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="dpi"
                label="DPI"
                name="dpi"
                disabled
                value={userInfo.dpi}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="genero"
                label="Género"
                name="genero"
                disabled
                value={userInfo.genero}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="localidad"
                label="Localidad"
                name="localidad"
                disabled
                value={`${userInfo.localidad}, ${userInfo.municipio}, ${userInfo.departamento}`}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <FormSectionTitle>Información laboral</FormSectionTitle>

            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="area"
                label="Area de trabajo"
                name="area"
                disabled
                value={userInfo.areaNombre}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="puesto"
                label="Puesto de trabajo"
                name="puesto"
                disabled
                value={userInfo.puestoNombre}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="renglon"
                label="Renglon presupuestario"
                name="renglon"
                disabled
                value={userInfo.renglon + " " + userInfo.renglonDesc}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid
              item
              className="dropDownListGridItem"
              xs={12}
              sm={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <DropDownList
                required
                endpoint={"/actividadInvestigacion"}
                selectedItem={actividadInv}
                setSelectedItem={setActividadInv}
                title="Actividad de investigación"
                selected={userInfo.actividadInv}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="profesion"
                label="Profesion"
                name="profesion"
                value={userInfo.profesion}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                fullWidth
                id="especialidad"
                label="Especialidad"
                name="especialidad"
                value={userInfo.especialidad}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <FormSectionTitle>Seguridad</FormSectionTitle>

            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña actual"
                type="password"
                id="password"
                helperText="Requerida para confirmar cualquier cambio en tu cuenta"
              />
            </Grid>
            <Grid item xs={0} sm={6}></Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                fullWidth
                name="newPassword"
                label="Nueva contraseña"
                type="password"
                id="newPassword"
                onChange={(e) => {
                  setNewPassword(e.target.value !== "");
                  setPasswordError(!validatePassword(e.target.value));
                }}
                error={passwordError}
                helperText={REGLAS_PASSWORD}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                margin="normal"
                required={newPassword}
                fullWidth
                name="confirmPassword"
                label="Confirmar contraseña"
                type="password"
                id="confirmPassword"
                onChange={() => setVerifyPasswordError(!verifyPassword())}
                error={verifyPasswordError}
              />
            </Grid>

            {errorText && (
              <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", marginTop: 1 }}>
                <Typography component="p" variant="body2" color="error">
                  {errorText}
                </Typography>
              </Grid>
            )}

            <Grid
              item
              xs={12}
              sx={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                marginTop: 2,
              }}
            >
              <Button type="submit" variant="contained" color="success" sx={{ mb: 2, px: 4 }}>
                Actualizar
              </Button>
            </Grid>
          </Grid>
        </Box>
        <DialogAlert
          title={dialog.title}
          text={dialog.text}
          open={openDialog}
          setOpen={setOpenDialog}
        />
      </Container>
    </LoaderBox>
  );
}

export { MiCuenta };
